module.exports = __webpack_public_path__ + "img/badge-list-thumb-055.759ab1a1.png";